var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMapMarker = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  width: "1em",
  height: "1em"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M12 11.67a1.75 1.75 0 0 1-1.212-.483 1.62 1.62 0 0 1-.502-1.167c0-.438.18-.857.502-1.167.321-.31.757-.483 1.212-.483s.89.174 1.212.483c.322.31.502.73.502 1.167 0 .217-.044.431-.13.631s-.213.382-.372.536q-.242.231-.556.357c-.314.126-.43.126-.656.126m0-6.27a4.9 4.9 0 0 0-3.394 1.353A4.53 4.53 0 0 0 7.2 10.02c0 3.465 4.8 8.58 4.8 8.58s4.8-5.115 4.8-8.58c0-1.225-.506-2.4-1.406-3.267A4.9 4.9 0 0 0 12 5.4"
})));
export default SvgMapMarker;